module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kgrON"))).then(() => parcelRequire('9Lwss'));